// extracted by mini-css-extract-plugin
export default {"link":"gCNh5tTI87","last":"CdhcPeCaBE"};